<lib-tablo-canva
  [printMode]="true"
  [currentPage]="currentPage$ | async"
  [publicSessionOrganizationId]="publicSessionOrganizationId"
  [template]="currentTemplate$ | async"
  [structure]="projectStructureToPassDown$ | async"
  [photoSourceGroups]="sourceGroups$ | async"
  [context]="context"
  [contextId]="contextId"
  [leadingChildId]="leadingChildId$ | async"
  [projectId]="projectId"
  (isCanvasReady)="canvasLoaded()"
  [updatedScale]="1"
  [disabled]="true"
  [photographerLogo]="photographerLogo"
  [publicSessionOrganizationGroupId]="publicSessionOrganizationGroupId"
  [isMockup]="isMockup"
></lib-tablo-canva>
